import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";

import { Observable, catchError, throwError } from "rxjs";

import { AlertBadge, CAE, HttpError, HttpErrorStatus } from "@models";
import { AlertService, AnalyticsService, ClientService } from "@services";

export const errorInterceptorFn: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const clS = inject(ClientService);
  const anS = inject(AnalyticsService);
  const alS = inject(AlertService);

  return next(req).pipe(
    catchError((err: HttpError) => {
      if (err.status === HttpErrorStatus.UNA) {
        anS.api("api_unauthorized_error_failed");

        clS.una$.set(true);
      } else if (req.context.get(CAE)) {
        const code = err?.error?.code;

        if (code) {
          anS.api(`api_${code}_error_failed`);
        }

        const base = "error.internal";

        alS.show({ text: `${base}.title`, message: `${base}.msg`, badge: AlertBadge.E });
      }

      return throwError(() => err);
    }),
  );
};
